<ng-container class="board-list--more-menu" *ngIf="canDelete()">
  <icon-triggered-context-menu
     [menu-items]="menuItems">
  </icon-triggered-context-menu>
</ng-container>
